import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "navbar navbar-expand-lg navbar-light position-absolute top-0 start-0 end-0",
  id: "Navbar"
}
const _hoisted_2 = { class: "container-fluid d-flex flex-row justify-content-around align-items-center ps-lg-4" }
const _hoisted_3 = { class: "logos col-6 col-lg-2 ms-lg-4 d-flex flex-row justify-content-center align-items-center" }
const _hoisted_4 = {
  class: "col-8 logo-ine d-flex justify-content-center align-items-center",
  href: "#"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  class: "col-2 ms-2 ms-lg-4 logo-pnud d-flex justify-content-center align-items-center",
  href: "#"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "menu col-6 col-lg-10 d-none d-lg-flex flex-column flex-lg-row justify-content-center justify-content-lg-center align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_smooth_scroll = _resolveDirective("smooth-scroll")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", _hoisted_4, [
          _createElementVNode("img", {
            src: require(`@/assets/images/logo-ine.png`)
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("a", _hoisted_6, [
          _createElementVNode("img", {
            src: require(`@/assets/images/logo-pnud.png`)
          }, null, 8, _hoisted_7)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _withDirectives((_openBlock(), _createBlock(_component_router_link, {
          class: "col-12 col-lg-2 text-center",
          to: "/",
          href: "#Topics"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Temas")
          ]),
          _: 1
        })), [
          [_directive_smooth_scroll]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_router_link, {
          class: "col-12 col-lg-3 text-center",
          to: "/",
          href: "#Questions"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Preguntas principales")
          ]),
          _: 1
        })), [
          [_directive_smooth_scroll]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_router_link, {
          class: "col-12 col-lg-3 text-center",
          to: "/",
          href: "#Explore"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Explora y compara datos")
          ]),
          _: 1
        })), [
          [_directive_smooth_scroll]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_router_link, {
          class: "col-12 col-lg-2 text-center",
          to: "/",
          href: "#Download"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Descarga datos")
          ]),
          _: 1
        })), [
          [_directive_smooth_scroll]
        ])
      ])
    ])
  ]))
}